import React from "react";
import { BOOKS } from "../../mock";
import { BookOpen, Feather } from "lucide-react";
import { SectionTitle } from "./About";

export default function Books() {
  return (
    <section id="books" className="scroll-smooth-section py-24 bg-cream/40 relative overflow-hidden">
      <div className="blob-saffron w-[420px] h-[420px] -top-32 -left-20 opacity-25" />
      <div className="blob-teal w-[380px] h-[380px] bottom-0 -right-20 opacity-20" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <SectionTitle
          kicker="Bibliography"
          title="Fifteen books across two languages"
          subtitle="Columns in Mathrubhumi, Kerala Kaumudi, Deepika and The Hindu — and fifteen original volumes spanning neurology, philosophy and literature."
        />

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {BOOKS.map((b, i) => (
            <div key={i} className="group relative lift">
              {/* Book cover */}
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-xl ring-1 ring-emerald-deep/15">
                {b.cover ? (
                  <>
                    <img
                      src={b.cover}
                      alt={b.title}
                      className="w-full h-full object-cover photo-enhance-soft transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                    {/* Subtle gradient at bottom for depth */}
                    <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
                  </>
                ) : (
                  <div className="book-card w-full h-full p-5 flex flex-col justify-between text-ivory">
                    <div className="flex justify-between items-start">
                      <BookOpen className="w-6 h-6 text-champagne" />
                      <span className="text-[10px] uppercase tracking-widest text-champagne/80">#{String(i + 1).padStart(2, "0")}</span>
                    </div>
                    <div>
                      <div className="font-display text-xl leading-tight">{b.title}</div>
                      <div className="text-xs uppercase tracking-widest text-champagne mt-2 flex items-center gap-1">
                        <Feather className="w-3 h-3" /> {b.lang}
                      </div>
                    </div>
                  </div>
                )}

                {/* Book number tag (always visible top-right) */}
                <span className="absolute top-3 right-3 bg-emerald-deep/90 backdrop-blur text-champagne text-[10px] uppercase tracking-[0.2em] font-bold px-2.5 py-1 rounded-full border border-champagne/30">
                  #{String(i + 1).padStart(2, "0")}
                </span>

                {/* Hover ring */}
                <div className="absolute inset-0 ring-0 ring-saffron/0 group-hover:ring-2 group-hover:ring-saffron/70 transition-all rounded-xl pointer-events-none" />
              </div>

              {/* Title and language below cover */}
              <div className="mt-4 px-1">
                <div className="font-display text-lg text-emerald-deep leading-tight">{b.title}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-gold mt-1.5 flex items-center gap-1">
                  <Feather className="w-3 h-3" /> {b.lang}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
